import { EventsSource } from './EventsSource';
import { IncidentsSource } from './IncidentsSource';
import { LocationsSource } from './LocationsSource';
import { ObjectivesSource } from './ObjectiveSource';
import { PathsSource } from './PathsSource';
import { PeopleSource } from './PeopleSource';
import { ExternalPeopleSource } from './ExternalPeopleSource';
import { ExternalVehiclesSource } from './ExternalVehiclesSource';
import { VehiclesSource } from './VehiclesSource';

export function Source(props) {
  switch (props.id) {
    case 'vehicles':
      return <VehiclesSource {...props} />;
    case 'people':
      return <PeopleSource {...props} />;
    case 'locations':
      return <LocationsSource {...props} />;
    case 'incidents':
      return <IncidentsSource {...props} />;
    case 'objectives':
      return <ObjectivesSource {...props} />;
    case 'events':
      return <EventsSource {...props} />;
    case 'paths':
      return <PathsSource {...props} />;
    case 'externalVehicles':
      return <ExternalVehiclesSource {...props} />;
    case 'externalPeople':
      return <ExternalPeopleSource {...props} />;
    default:
      return null;
  }
}
